import React, { use } from 'react'

import { Link as ReactRouterLink } from 'react-router-dom'
import { Box, Text } from '@chakra-ui/react'

import { HeaderContext } from '@/context/Header'
import ProfileDropDown from '@/views/components/ProfileDropDown'

export const Header: React.FC = () => {
  const { middleContent } = use(HeaderContext)

  return (
    <header className="flex items-center justify-between gap-3 md:gap-4">
      <div className="flex items-center flex-grow min-w-0">
        <Text
          as={ReactRouterLink}
          to={'/home'}
          className={'rounded-full font-bold'}
          fontSize={'3xl'}
        >
          hirehire
        </Text>
        <Box
          py={'0.13rem'}
          px={'0.41rem'}
          mt={'-35px'}
          ml={'-2px'}
          backgroundColor={'#8B77FB'}
          color={'white'}
          fontWeight={'bold'}
          fontSize={'0.75rem'}
          rounded={'1.8555rem'}
        >
          Beta
        </Box>
        {middleContent}
      </div>
      <ProfileDropDown />
    </header>
  )
}
